// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ff-text-shadow {
  text-shadow: 3px 6px 6px var(--text-shadow);
}

@media (min-width: 720px) {
  .text-alignment-custom-offset {
    position: absolute;
    text-align: start;
    padding: 0;
    top: var(--text-alignment-offset-top);
    left: var(--text-alignment-offset-left);
  }
}
.av-mode.av-mode__color-text:not(.av-mode__on) .fs-accent {
  color: var(--accent-color, var(--color-text));
}

.newsletter__block-content-accent.fs-accent,
.image-with-text__text-container-accent.fs-accent,
.slideshow-slide__text-container-accent.fs-accent {
  color: var(--accent-color, var(--color-text));
}

@media (max-width: 719px) {
  .text-alignment-custom-offset-mobile {
    position: absolute;
    text-align: start;
    padding: 0;
    top: var(--text-alignment-mobile-offset-top);
    left: var(--text-alignment-mobile-offset-left);
  }
}
.video-hero__text-container,
.image-hero__text-container,
.slideshow-slide__text-container-inner {
  max-width: var(--text-width-mobile);
}

@media (min-width: 720px) {
  .video-hero__text-container,
  .image-hero__text-container,
  .slideshow-slide__text-container-inner {
    max-width: var(--text-width);
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/text.scss"],"names":[],"mappings":"AACA;EACE,2CAAA;AAAF;;AAIA;EACE;IACE,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,qCAAA;IACA,uCAAA;EADF;AACF;AAQM;EACE,6CAAA;AANR;;AAgBE;;;EACE,6CAAA;AAXJ;;AAeA;EACE;IACE,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,4CAAA;IACA,8CAAA;EAZF;AACF;AAgBA;;;EAGE,mCAAA;AAdF;;AAiBA;EACE;;;IAGE,4BAAA;EAdF;AACF","sourcesContent":["// text-shadow\n.ff-text-shadow {\n  text-shadow: 3px 6px 6px var(--text-shadow);\n}\n\n// custom text offset alignment\n@media (min-width: 720px) {\n  .text-alignment-custom-offset {\n    position: absolute;\n    text-align: start;\n    padding: 0;\n    top: var(--text-alignment-offset-top);\n    left: var(--text-alignment-offset-left);\n  }\n}\n\n// accent color\n.av-mode {\n  &.av-mode__color-text {\n    &:not(.av-mode__on) {\n      .fs-accent {\n        color: var(--accent-color, var(--color-text));\n      }\n    }\n  }\n}\n\n.newsletter__block-content-accent,\n.image-with-text__text-container-accent,\n  // TODO: this style can be removed once slideshow av mode will be implemented\n.slideshow-slide__text-container-accent {\n  &.fs-accent {\n    color: var(--accent-color, var(--color-text));\n  }\n}\n\n@media (max-width: 719px) {\n  .text-alignment-custom-offset-mobile {\n    position: absolute;\n    text-align: start;\n    padding: 0;\n    top: var(--text-alignment-mobile-offset-top);\n    left: var(--text-alignment-mobile-offset-left);\n  }\n}\n\n// custom text width\n.video-hero__text-container,\n.image-hero__text-container,\n.slideshow-slide__text-container-inner {\n  max-width: var(--text-width-mobile);\n}\n\n@media (min-width: 720px) {\n  .video-hero__text-container,\n  .image-hero__text-container,\n  .slideshow-slide__text-container-inner {\n    max-width: var(--text-width);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
